"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BarGetOutputSchema = exports.BarGetInputSchema = exports.BarUpdateOutputSchema = exports.BarUpdateInputSchema = void 0;
const zod_1 = require("zod");
const bar_1 = require("../bar");
const user_1 = require("../user");
/**
 * POST - /api/staffbar/bar
 *
 * This endpoint is used to update the bar configuration
 *
 */
exports.BarUpdateInputSchema = zod_1.z.object({
    bar: bar_1.BarSchema,
});
exports.BarUpdateOutputSchema = zod_1.z.object({
    bar: bar_1.BarSchema,
});
/**
 * GET - /api/staffbar/bar
 *
 * This endpoint is used to get the bar configuration
 */
exports.BarGetInputSchema = zod_1.z.object({});
exports.BarGetOutputSchema = zod_1.z.object({
    userPreferences: user_1.UserPreferencesSchema,
    bar: bar_1.BarSchema,
});
